import React, { Component } from "react";
import { connect } from "react-redux";

import { injectIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import "./styles.scss";

class ControlResults510 extends Component {
  getType = (control) => {
    switch (control) {
      case "wildType":
        return this.props.intl.formatMessage({
          id: "Wild type macrophage cells",
          defaultMessage: "Wild type macrophage cells",
          description: "",
        });

      case "edit7":
        return this.props.intl.formatMessage({
          id: "Edit 7 cells",
          defaultMessage: "Edit 7 cells",
          description: "",
        });

      case "edit4":
        return this.props.intl.formatMessage({
          id: "Edit 4 cells",
          defaultMessage: "Edit 4 cells",
          description: "",
        });

      case "pancreasCells":
        return this.props.intl.formatMessage({
          id: "Pancreas cells",
          defaultMessage: "Pancreas cells",
          description: "",
        });

      default:
        return null;
    }
  };

  renderControls = (type) => {
    if (type == "Sample") {
      const data = this.props.cellCultures.sample;

      if (data.length == 2) {
        return this.getType(data[0]) + ", " + this.getType(data[1]);
      } else if (data.length == 1) {
        return this.getType(data[0]);
      } else {
        return "";
      }
    } else if (type == "Positive Control") {
      const data = this.props.cellCultures.positiveControl;
      if (data.length == 2) {
        return this.getType(data[0]) + ", " + this.getType(data[1]);
      } else if (data.length == 1) {
        return this.getType(data[0]);
      } else {
        return "";
      }
    } else if (type == "Negative Control") {
      const data = this.props.cellCultures.negativeControl;
      if (data.length == 2) {
        return this.getType(data[0]) + ", " + this.getType(data[1]);
      } else if (data.length == 1) {
        return this.getType(data[0]);
      } else {
        return "";
      }
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="Gel510-results">
        <div className="table-wrapper">
          <table className="results-table">
            <tr>
              <th></th>
              <th
                aria-label={this.props.intl.formatMessage({
                  id: "Positive control column. Wild type macrophage cells.",
                  defaultMessage:
                    "Positive control column. Wild type macrophage cells.",
                  description: "",
                })}
              >
                <FormattedMessage
                  id="Positive control"
                  defaultMessage="Positive control"
                  description=""
                />
              </th>
              <th
                aria-label={this.props.intl.formatMessage({
                  id: "Negative control column. Pancreas cells.",
                  defaultMessage: "Negative control column. Pancreas cells.",
                  description: "",
                })}
              >
                <FormattedMessage
                  id="Negative control"
                  defaultMessage="Negative control"
                  description=""
                />
              </th>
              <th
                aria-label={this.props.intl.formatMessage({
                  id: "Samples column. Containing Edit 4 cells and edit 7 cells.",
                  defaultMessage:
                    "Samples column. Containing Edit 4 cells and edit 7 cells.",
                  description: "",
                })}
              >
                <FormattedMessage
                  id="Samples"
                  defaultMessage="Samples"
                  description=""
                />
              </th>
            </tr>
            <tr>
              <td style={{ background: "white" }}>
                <b>
                  <FormattedMessage
                    id="Predicted controls and samples"
                    defaultMessage="Predicted controls and samples"
                    description=""
                  />
                </b>
              </td>
              <td>
                {this.renderControls(
                  this.props.intl.formatMessage({
                    id: "Positive Control",
                    defaultMessage: "Positive Control",
                    description: "",
                  })
                )}
              </td>
              <td>
                {this.renderControls(
                  this.props.intl.formatMessage({
                    id: "Negative Control",
                    defaultMessage: "Negative Control",
                    description: "",
                  })
                )}
              </td>
              <td>
                {this.renderControls(
                  this.props.intl.formatMessage({
                    id: "Sample",
                    defaultMessage: "Sample",
                    description: "",
                  })
                )}
              </td>
            </tr>
            <tr>
              <td style={{ background: "white" }}>
                <b>
                  <FormattedMessage
                    id="Correct controls and samples"
                    defaultMessage="Correct controls and samples"
                    description=""
                  />
                </b>
              </td>
              <td>
                <FormattedMessage
                  id="Wild type macrophage cells"
                  defaultMessage="Wild type macrophage cells"
                  description=""
                />
              </td>
              <td>
                <FormattedMessage
                  id="Pancreas cells"
                  defaultMessage="Pancreas cells"
                  description=""
                />
              </td>
              <td>
                <FormattedMessage
                  id="Edit 4 cells, Edit 7 cells"
                  defaultMessage="Edit 4 cells, Edit 7 cells"
                  description=""
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cellCultures: state.predictions.cellCultures,
  };
};

const ControlResults510WithIntl = injectIntl(ControlResults510);

export default connect(mapStateToProps)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ControlResults510WithIntl {...props} />
  </TranslationsProvider>
));
